import {
    CONFIRMED_GET_CAMPAIGNS,
    CONFIRMED_CREATE_CAMPAIGN,
    CONFIRMED_DELETE_CAMPAIGN,
    CONFIRMED_EDIT_CAMPAIGN,
    CONFIRMED_GET_CAMPAIGNS_BY_DATE,
  } from "../types/CampaignTypes";
  
  import {
    getCampaigns,
    createCampaign,
    updateCampaign,
    deleteCampaign,
    formatCampaigns,
    getCampaignsByDate
  } from "../../services/CampaignService";
  
  import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";
  
  // Get Campaign list
  export function getCampaignAction(
    pagination = true,
    pageid = 0,
    search_by = "",
    search_keyword = "",
    sort_by = "",
    sort_order = ""
  ) {
    return async (dispatch) => {
      try {
        const response = await getCampaigns(
          pagination,
          pageid,
          search_by,
          search_keyword,
          sort_by,
          sort_order
        );
  
        if (response?.status === 200 && response.data?.campaigns) {
          dispatch({
            type: CONFIRMED_GET_CAMPAIGNS,
            payload: {
              list: formatCampaigns(response.data.campaigns),
              num_rows: response.data.total_campaigns || 0,
            },
          });
        }
      } catch (error) {
        console.error("Campaign fetch error:", error);
      }
    };
  }
  export function getCampaignByDateAction(target_date) {
    return async (dispatch) => {
      try {
        const response = await getCampaignsByDate(target_date);
  
        if (response?.status === 200) {
          dispatch({
            type: CONFIRMED_GET_CAMPAIGNS_BY_DATE,
            payload: {
              list: response.data.campaigns,
              num_rows: response.data.total_campaigns,
              target_date: response.data.target_date,
            },
          });
        }
      } catch (error) {
        console.error(error);
      }
    };
  }
  
  
  
  // Delete Campaign
  export function deleteCampaignAction(campaign_id) {
    return async (dispatch) => {
      try {
        await deleteCampaign(campaign_id);
  
        dispatch({
          type: CONFIRMED_DELETE_CAMPAIGN,
          payload: { campaign_id: campaign_id},
        });
  
        handleSuccess("Campaign deleted successfully!");
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to delete Campaign");
      }
    };
  }
  
  
  // Create Campaign
  export function createCampaignAction(campaignData, navigate) {
    return async (dispatch) => {
      try {
        const response = await createCampaign(campaignData);
  
        if (response?.status === 200) {
          dispatch({
            type: CONFIRMED_CREATE_CAMPAIGN,
            payload: formatCampaigns([response.data.campaigns || response.data])[0],
          });
  
          handleSuccess("Campaign created successfully!");
          navigate("/campaign");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to create Campaign");
      }
    };
  }
  
  
  // Update Campaign
  export function updateCampaignAction(campaignData, campaignId, navigate) {
    return async (dispatch) => {
      try {
        const response = await updateCampaign({
          ...campaignData,
          campaign_id: campaignId,
        });
  
        if (response?.status === 200) {
          dispatch({
            type: CONFIRMED_EDIT_CAMPAIGN,
            payload: formatCampaigns([response.data.campaigns || response.data])[0],
          });
  
          handleSuccess("Campaign updated successfully!");
          navigate("/campaign");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to update Campaign");
      }
    };
  }
  
  